export var S3_URL = 'https://static.golfgamebook.com';
export var GameOptions;
(function (GameOptions) {
    GameOptions["PRIMARY"] = "primary";
    GameOptions["SECONDARY"] = "secondary";
    GameOptions["SCRATCH"] = "scratch";
})(GameOptions || (GameOptions = {}));
export var Holes;
(function (Holes) {
    Holes["FRONT9"] = "f9";
    Holes["BACK9"] = "b9";
    Holes["FULL18"] = "18";
})(Holes || (Holes = {}));
export var PlayerStatus;
(function (PlayerStatus) {
    PlayerStatus["OK"] = "OK";
    PlayerStatus["DQ"] = "DQ";
    PlayerStatus["DNS"] = "DNS";
    PlayerStatus["RTD"] = "RTD";
    PlayerStatus["CUT"] = "CUT";
})(PlayerStatus || (PlayerStatus = {}));
